export default `#version 300 es
precision highp float;

out vec4 outColor;
in vec2 vertexCoord;
uniform sampler2D u_image;
uniform sampler2D textureImage;

uniform float isPaletteSwapped;
uniform sampler2D paletteImage;

uniform float isMasked;
uniform sampler2D maskImage;
uniform vec2 imagePosition; // screenspace coordinates of where this start and ends. used to calculate mask.

uniform vec3 gradientColors[15];
uniform float gradientColorsCount;

uniform vec4 tintColor;
uniform float tintIntensity;
uniform vec4 outlineColor;
uniform float outlineThickness;
uniform vec2 spriteSize;
uniform float opacity;
uniform float grayscaleIntensity;
uniform float isFlipped;

const float PI = 3.14159265358979323846264;
const float TAU = PI * 2.0;
const vec4 filterClamp = vec4(0.0, 0.0, 0.0, 0.0);
const float samples = 50.0;

float getLuma(vec3 color) {
  return (max(max(color.r, color.g), color.b) + min(min(color.r, color.g), color.b)) / 2.0;
}

void main() {
    vec4 textureColor = texture(textureImage, vertexCoord);

    // OUTLINE //
    if(outlineThickness > 0.0) {
        if(textureColor.a < 0.9) {
            float outlineAlpha = 0.0;
            vec2 displacement = vec2(1.0 / (spriteSize.x / outlineThickness), 1.0 / (spriteSize.y / outlineThickness));
            for(float angle = 0.0; angle <= TAU; angle += TAU / samples) {
                vec2 displacedPosition;
                displacedPosition.x = vertexCoord.x + displacement.x * cos(angle);
                displacedPosition.y = vertexCoord.y + displacement.y * sin(angle);
                vec4 displacedColor = texture(u_image, displacedPosition);
                outlineAlpha = max(outlineAlpha, displacedColor.a);
            }
            if(textureColor.a < 1.0 && outlineAlpha > 0.0) {
                outColor = outlineColor;
            } else {
                outColor = textureColor;
            }
            return;

            // // OUTLINE //
            // vec2 offset = vec2(1.0 / spriteSize.x, 1.0 / spriteSize.y);
            // float outlineAlpha = texture(u_image, vec2(vertexCoord.x + offset.x, vertexCoord.y)).a
            //     + texture(u_image, vec2(vertexCoord.x, vertexCoord.y - offset.y)).a
            //     + texture(u_image, vec2(vertexCoord.x - offset.x, vertexCoord.y)).a
            //     + texture(u_image, vec2(vertexCoord.x, vertexCoord.y + offset.y)).a;
            // if(outlineAlpha > 0.0) {
            //     outColor = outlineColor;
            // }
        }
    }

    // ALPHA //
    if(textureColor.a == 0.0) {
        discard;
    }

    // MASKED //
    if(isMasked == 1.0) {
        vec2 maskingPosition;
        float vertexCoordX = vertexCoord.x;
        float vertexCoordY = vertexCoord.y;
        if(isFlipped == 1.0) {
            vertexCoordX = 1.0 - vertexCoord.x;
        }
        maskingPosition.x = (imagePosition.x + (vertexCoordX * spriteSize.x)) / 512.0;
        maskingPosition.y = (imagePosition.y + (vertexCoordY * spriteSize.y)) / 288.0;
        if(texture(maskImage, maskingPosition).a < 1.0) {
            discard;
        }
    }

    vec4 inputColor = textureColor;

    // PALETTE SWAP //
    if(isPaletteSwapped == 1.0) {
        inputColor = texture(paletteImage, textureColor.xy);
    }

    // TINT //
    vec4 finalColor = mix(inputColor, tintColor, tintIntensity);
    finalColor.a = textureColor.a;

    // OPACITY //
    finalColor.a = finalColor.a * opacity;

    // GRAYSCALE //
    if(grayscaleIntensity > 0.0) {
        float luma = dot(finalColor.rgb, vec3(0.299, 0.587, 0.114));
        finalColor = vec4(vec3(luma), finalColor.a);
    }

    // GRADIENT MAPPING //
    if(gradientColorsCount > 0.0) {
        int colorCount = int(gradientColorsCount);
        float luma = getLuma(textureColor.rgb);
        vec4 interpolatedColor;

        vec3 darkerColor;
        vec3 lighterColor;
        float darkerLuma;
        float lighterLuma;
        if(luma <= getLuma(gradientColors[0].rgb)) {
            darkerColor = vec3(0.0, 0.0, 0.0);
            lighterColor = gradientColors[0].rgb;
            darkerLuma = 0.0;
            lighterLuma = getLuma(gradientColors[0].rgb);
        } else if(getLuma(gradientColors[colorCount - 1].rgb) < luma) {
            darkerColor = gradientColors[colorCount - 1].rgb;
            lighterColor = vec3(1.0, 1.0, 1.0);
            darkerLuma = getLuma(gradientColors[colorCount - 1].rgb);
            lighterLuma = 1.0;
        } else {
            for(int colorIndex = 0; colorIndex < colorCount - 1; colorIndex++) {
                float thisLuma = getLuma(gradientColors[colorIndex].rgb);
                float nextLuma = getLuma(gradientColors[colorIndex + 1].rgb);
                if(thisLuma < luma && luma <= nextLuma) {
                    darkerLuma = thisLuma;
                    lighterLuma = nextLuma;
                    darkerColor = gradientColors[colorIndex].rgb;
                    lighterColor = gradientColors[colorIndex + 1].rgb;
                    break;
                }
            }
        }

        if(getLuma(lighterColor) - getLuma(darkerColor) < 0.0001) {
            finalColor = vec4(lighterColor, finalColor.a);
        } else {
            float percentageBetweenStops = (getLuma(lighterColor) - luma) / (getLuma(lighterColor) - getLuma(darkerColor));
            interpolatedColor = vec4(darkerColor * percentageBetweenStops + lighterColor * (1.0 - percentageBetweenStops), finalColor.a);
            finalColor = interpolatedColor;
        }
    }

    outColor = finalColor;
}
`